import { PropsWithChildren, ReactNode, useEffect, useRef } from 'react';
import { FieldValues, UseControllerProps, UseFormResetField } from 'react-hook-form';

interface CasFormConditionalDisplayProps<TFormValues extends FieldValues> {
  name: UseControllerProps<TFormValues>['name'];
  show: boolean;
  resetField: UseFormResetField<TFormValues>;
}

export function CasFormConditionalDisplay<TFormValues extends FieldValues>({
  name,
  children,
  show,
  resetField,
}: PropsWithChildren<CasFormConditionalDisplayProps<TFormValues>>): ReactNode {
  const showRef = useRef<boolean>(show);

  useEffect(() => {
    // Only run the logic when the show prop has changed.
    if (showRef.current !== show) {
      // Update the ref to the new show state.
      showRef.current = show;
      // If the field is being hidden, reset the field to the default value provided to the useForm hook.
      if (!show) {
        resetField(name);
      }
    }
  }, [show, name, resetField]);

  if (show) {
    return children;
  } else {
    return <div style={{ display: 'none' }}>{children}</div>;
  }
}

export default CasFormConditionalDisplay;
